import { connect } from "react-redux";
import dispatchers from "ui/molecule/header/dispatchers";
import selectors from "ui/molecule/header/selectors";
import HeaderUI from "ui/molecule/header/HeaderUI";

// alebo takto temu mame v props export default withStyles(customStyles, { withTheme: true })(AddBabySitterUI);
export default connect(selectors, dispatchers)(HeaderUI);
